import firebase from "store/firebase";
import "firebase/firestore";
import { AnyAction, Dispatch } from "redux";
import type { RootState } from "store/reducer";
import { StoreError } from "store/errors";
import { loadIdResource } from "store/util/id-resource";
import { normalizeDisplayName } from "../users/utils";
import {
  ACCOUNT_ACTION_TYPES,
  AccountProfile,
  accountActions,
} from "./reducer";

export const ACTION_ACCOUNT_LOADING = ACCOUNT_ACTION_TYPES.startedLoading;
export const ACTION_ACCOUNT_LOADED = ACCOUNT_ACTION_TYPES.loaded;
export const ACTION_ACCOUNT_LOAD_ERROR = ACCOUNT_ACTION_TYPES.errored;

/** Fetch the user profile at users/<email>. If no doc exists yet, returns
 *  a profile with `displayName: null` so the screen renders the form
 *  instead of treating it as an error. */
export default function load(email: string) {
  return async (
    dispatch: Dispatch<AnyAction>,
    getState: () => RootState
  ) => {
    return loadIdResource<AccountProfile, RootState>(
      email,
      async () => {
        if (!email) {
          throw new StoreError("No current user.");
        }
        const doc = await firebase
          .firestore()
          .collection("users")
          .doc(email)
          .get();
        return {
          id: email,
          email,
          displayName: normalizeDisplayName(doc?.data()?.displayName),
        };
      },
      {
        actions: accountActions,
        selectSlice: (root) => root.account,
      }
    )(dispatch as any, getState);
  };
}
